// extracted by mini-css-extract-plugin
module.exports = {"panel-head":"Joh-lNAt6AFnGlSIfWcQM","icon-container":"nfTEy5ASLM1IB_a0YT1Mf","input-ecommerce":"_2h9yjYn0_5xJhssAxJYiSV"};